export default __webpack_public_path__ + "static/media/p31.ec6b658a.jpg";